<template>
  <v-row>
    <v-col cols="12" v-if="!readonly">
      <AutocompleteSelectSubGroup
        :user="user"
        label="Grupos/Tropas"
        v-model="subGroupIds"
        :returnObject="false"
        :multiple="true"
        density="compact"
      />
    </v-col>
    <v-col cols="12">
      <ListFromTo
        :title="loading ? 'Carregando destinatários...' : 'Destinatários'"
        :listFrom="lstLegalPeople"
        :listTo="value"
        @updated="submitUpdate"
        listFromKey="name"
        listToKey="name"
        density="compact"
        :bigList="true"
        :loading="requestingApi"
        :readonly="readonly"
      >
        <template v-slot:search>
          <div>
            <v-form :submit="searchPeople">
              <v-text-field
                label="Pesquisar pessoas pelo nome"
                hide-details
                v-model="searchText"
                @click:append-inner="searchPeople"
                clearable
                append-inner-icon="mdi-magnify"
                density="compact"
                :loading="requestingApi"
                :disabled="requestingApi"
              >
              </v-text-field>
            </v-form>
          </div>
        </template>
      </ListFromTo>
    </v-col>
  </v-row>
</template>
<script>
import AutocompleteSelectSubGroup from './AutocompleteSelectSubGroup.vue';
import ListFromTo from "./ListFromTo.vue";
import api from '@/services'
export default {
  components: { ListFromTo, AutocompleteSelectSubGroup },
  props: {
    user: Object,
    modelValue: Object,
    newsId: Number,
    loading: Boolean,
    readonly: Boolean
  },
  emits: ["update:modelValue"],
  data() {
    return {
      requestingApi: null,
      lstLegalPeople: [],
      subGroupIds: null,
      searchText: null,
    };
  },
  created() {
    var vm = this;
    vm.$emit("loadReceivers");
  },
  mounted() {},
  methods: {
    submitUpdate(receivers) {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.newsReceiver
          .updateOrCreate(vm.newsId, {items: receivers.map((obj) => {return {news_id: vm.newsId, legal_person_id: obj.id}})})
          .then((result) => {
            vm.$emit("updated", result);
            vm.$notify({
              type: "success",
              text: "Destinatários atualizados com sucesso",
            });
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    searchPeople() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.legalPerson
          .search({
            searchText: vm.searchText,
            types: [vm.$LEGAL_PEOPLE_TYPES_DIC.PADRAO],
            limit: 90000,
            sub_group_ids: vm.subGroupIds,
          })
          .then((result) => {
            vm.lstLegalPeople = result;
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    subGroupIds() {
      this.searchPeople()
    }
  },
};
</script>